import { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Button';
import ContactAgentModal from 'components/modal/ContactAgentModal';
import StyledDiv from 'components/styled/StyledDiv';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_PRIMARY_COLOUR } from 'shared/constants/styleConstants';

export default function SpeakToYourAgentCardWide({
  styles = '',
  type = 'booking',
  context,
}) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  const { agent = {} } = useSelector((state) => state.currentUser);
  const agentFirstName = agent?.fullName?.split?.(' ')?.[0] || '';
  const [openModal, setOpenModal] = useState(false);

  const openModalHandler = () => {
    setOpenModal(!openModal);
  };

  const customStyles = `
    border-radius: 0.5rem;
    background: ${primaryColour || DEFAULT_PRIMARY_COLOUR};
    width: 100%;
    margin-top: 40px;
  
    ${styles}
  `;

  return (
    <>
      <div className="hidden lg:block mx-4 grid:mx-0">
        <StyledDiv customStyles={customStyles}>
          <div className="px-6 py-8 lg:flex lg:justify-between items-center">
            <div className="text-white xs:text-center lg:text-left">
              <div className="font-medium text-[24px]">
                Message Customer Services
              </div>
              <div className="pt-2">
                Need to ask a question about your{' '}
                {type === 'quote' ? 'quote' : 'booking'}?
              </div>
            </div>
            <div className="mt-7 flex xs:justify-center lg:mt-0 lg:flex-row-reverse">
              <Button
                label={`Message ${agentFirstName}`}
                className="mr-3 ml-6 grow xs:grow-0"
                onClick={openModalHandler}
                secondary
              />
            </div>
          </div>
        </StyledDiv>
      </div>
      <ContactAgentModal
        assignee={agent}
        openModal={openModal}
        setOpenModal={setOpenModal}
        context={context}
      />
    </>
  );
}
